import BildivngInvoicesInfo from '../../components/billing-invoices/billing-invoices-info/billing-invoices-info'
import BillingInvoicesTable from '../../components/billing-invoices/billing-invoices-table/billing-invoices-table'
import { Space } from 'antd'
import React from 'react'

const BildivngInvoices: React.FC = () => {
  return (
    <Space orientation="vertical" size={18}>
      <div className="studios-area-page-title">发票相关</div>
      <Space orientation="vertical" size={24}>
        <BildivngInvoicesInfo />
        <BillingInvoicesTable />
      </Space>
    </Space>
  )
}
export default BildivngInvoices
